import React, { Component } from 'react';
import Page from '../../containers/page';
import FormBuilder from '../../form-builder';
import RouteComponent from '../../helpers/route';
import { required} from '../../form-builder/validation';
import Swal from 'sweetalert2'

class SynchronizationPage extends RouteComponent {
    constructor(props) {
        super(props);
        this.state = {
            loader: false,
            loaderReport: false,
            loaderSyncPrice: false,
            form: {
                skus: ''
            },
            priceForm: {
                customerId: ''
            }
        }
    }


    render() {

        return (
            <div>
                <div className="section-title title-options">
                    <h1>Syncronization</h1>
                </div>

                <div>
                    <div className="side-margin">
                        <FormBuilder
                            registerSubmitAction={(submit) => this.submit = submit}
                            classNameForm={"add-form-container"}
                            initialValues={this.state.priceForm}
                            lang={this.props.lang}
                            onSubmit={async (data) => {
                                if (data.customerId) {
                                    this.setState({loaderSyncPrice: true})
                                    this._api('sync-prices', {customerId: data.customerId}, (data) => {
                                        const {result, status} = data
                                        if(status !== 200) {
                                            Swal.fire({
                                                icon: 'error',
                                                title: 'Oops...',
                                                text: result?.error || "Server error",
                                            })
                                        }
                                        this.setState({priceForm: {customerId: ''}})
                                        this.setState({loaderSyncPrice: false})
                                    }, (error) => {

                                        this.setState({loaderSyncPrice: false})
                                    });
                                }
                            }}

                            fields={[
                                {
                                    type: 'row',
                                    children: [


                                        {
                                            type: 'col',
                                            width: {lg: 12, sm: 12, xs: 12},
                                            children: [
                                                {
                                                    type: 'block',
                                                    header: 'SYNC CUSTOMER PRICES',
                                                    style: {paddingBottom: 33, marginTop: 20},
                                                    children: [


                                                        {
                                                            type: 'col',
                                                            width: {lg: 12, sm: 12, xs: 12},
                                                            children: [
                                                                {
                                                                    type: 'text',
                                                                    name: 'customerId',
                                                                        label: 'Customer ID',
                                                                    multilang: false,
                                                                    validate: [
                                                                        required('Customer number is required!')
                                                                    ]
                                                                },

                                                            ]
                                                        },
                                                        {
                                                            type: 'button',
                                                            width: {lg: 4, sm: 6, xs: 6},
                                                            action: 'submit',
                                                            children: 'RUN',
                                                            loader: this.state.loaderSyncPrice,
                                                            className: 'form-button',
                                                        },

                                                    ]
                                                }]
                                        },


                                    ],
                                },

                            ]}
                        ></FormBuilder>
                    </div>
                    <div className="side-margin">
                        <FormBuilder
                            registerSubmitAction={(submit) => this.submit = submit}
                            classNameForm={"add-form-container"}
                            initialValues={this.state.form}
                            lang={this.props.lang}
                            onSubmit={async (data) => {
                                if (data.skus) {
                                    const skus = await data.skus.split(',')
                                    const payload = {skus: skus}
                                    this.setState({loader: true})
                                    this._api('save', payload, () => {
                                        this.setState({form: {skus: ''}})
                                        this.setState({loader: false})
                                    }, () => {
                                        this.setState({form: {skus: ''}})
                                        this.setState({loader: false})
                                    });
                                }
                            }}

                            fields={[
                                {
                                    type: 'row',
                                    children: [


                                        {
                                            type: 'col',
                                            width: {lg: 12, sm: 12, xs: 12},
                                            children: [
                                                {
                                                    type: 'block',
                                                    header: 'IMPORT PRODUCTS WITHOUT PHOTOS',
                                                    style: {paddingBottom: 33, marginTop: 20},
                                                    children: [


                                                        {
                                                            type: 'col',
                                                            width: {lg: 12, sm: 12, xs: 12},
                                                            children: [
                                                                {
                                                                    type: 'text',
                                                                    name: 'skus',
                                                                    label: 'SKUS',
                                                                    multilang: false,
                                                                    validate: [
                                                                        required('SKUS is required!')
                                                                    ]
                                                                },

                                                            ]
                                                        },
                                                        {
                                                            type: 'button',
                                                            width: {lg: 4, sm: 6, xs: 6},
                                                            action: 'submit',
                                                            children: 'RUN',
                                                            loader: this.state.loader,
                                                            className: 'form-button',
                                                        },

                                                    ]
                                                }]
                                        },


                                    ],
                                },

                            ]}
                        ></FormBuilder>
                    </div>
                    <div className="side-margin">
                        <FormBuilder
                            registerSubmitAction={(submit) => this.submit = submit}
                            classNameForm={"add-form-container"}
                            initialValues={this.state.form}
                            lang={this.props.lang}
                            onSubmit={async (data) => {
                                this.setState({loaderReport: true})
                                this._api('generate-report', (data) => {
                                    this.setState({loaderReport: false})
                                }, () => {
                                    this.setState({loaderReport: false})
                                });

                            }}

                            fields={[
                                {
                                    type: 'row',
                                    children: [


                                        {
                                            type: 'col',
                                            width: {lg: 12, sm: 12, xs: 12},
                                            children: [
                                                {
                                                    type: 'block',
                                                    header: 'GENERATE XLSX REPORT',
                                                    style: {paddingBottom: 33, marginTop: 20},
                                                    children: [

                                                        {
                                                            type: 'button',
                                                            width: {lg: 4, sm: 6, xs: 6},
                                                            action: 'submit',
                                                            children: 'RUN',
                                                            loader: this.state.loaderReport,
                                                            className: 'form-button',
                                                        },


                                                    ]
                                                }]
                                        },


                                    ],
                                },


                            ]}
                        ></FormBuilder>
                    </div>
                </div>
            </div>

        )
    }
}

export default Page(SynchronizationPage);

/*

*/